<div class="message-container p-1" [ngStyle]="{width: width + 'px'}">
    <mat-card fxLayout="column" class="message-card">
        <mat-card-header fxFlex="nogrow" class="mb-2">
            <mat-card-title [ngStyle]="{width: width - (width * 0.2) + 'px'}" class="chat-title">{{getChatNames()}}</mat-card-title>
        </mat-card-header>
        <mat-card-content #messageWindow class="chat-window">
                <div *ngFor="let message of chatMessages">
                    <div fxLayout="column" [ngStyle]="{color: getColor(message.username)}">
                        <div fxLayout="row" fxLayoutAlign="space-between" class="mt-2 mr-3">
                            <div class="message-header">{{message.username}}</div>

                            <div class="message-time">{{toHrDate(message.date)}}</div>
                        </div>
                        <div class="message-body mt-3 mr-1">{{message.message}}</div>
                        <span class="message-dividier mt-2"></span>
                    </div>
                </div>
        </mat-card-content>
        <mat-card-footer fxFlex="nogrow" class="message-area">
            <app-message-window (messageConfirmed)="send($event)"></app-message-window>
        </mat-card-footer>
    </mat-card>
</div>